import React from "react";
import { Area, Bar, CartesianGrid, ComposedChart, Line, Tooltip, XAxis, YAxis } from "recharts";

// import props
import { composedGraphProp } from "app/reporting/modules/operator/props";

const ComposedGraph = (props) => {
  const { data, width = 400, height = 250 } = props;
  const margin = {
    top: 20,
    right: 20,
    bottom: 20,
    left: 20,
  };
  return (
    <ComposedChart width={width} height={height} data={data} margin={margin}>
      <CartesianGrid stroke="#f5f5f5" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Area type="monotone" dataKey="amt" fill="#8884d8" stroke="#8884d8" />
      <Bar dataKey="pv" barSize={20} fill="#413ea0" />
      <Line type="monotone" dataKey="uv" stroke="#ff7300" />
    </ComposedChart>
  );
};

ComposedGraph.propTypes = composedGraphProp.type;

export default ComposedGraph;
